// extracted by mini-css-extract-plugin
export var displayNone = "_re-6";
export var imgContainer = "_re-2";
export var overflowHidden = "_re-3";
export var productInfoCardButtonContainer = "_re-5";
export var productTitleText = "_re-4";
export var rightArrow = "_re-1";
export var rightArrowContainer = "_re-0";